import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { PageTitleStore } from 'stores';
import { Sort } from '../sort-filter';

export interface ListingsHeaderBarProps {
  pageTitleStore?: PageTitleStore;
}

export const ListingsHeaderBar = inject('pageTitleStore')(
  observer(({ pageTitleStore }: ListingsHeaderBarProps) => {
    const { subTitle } = pageTitleStore;

    return (
      <UitkLayoutFlex
        data-test-id="listing-header-bar"
        justifyContent="space-between"
        alignItems="center"
        space="two"
        className="uitk-type-paragraph-200"
        direction="row-reverse"
      >
        <>
          <UitkLayoutFlexItem minWidth="quarter_width">
            <div>
              <Sort keySuffix="onACol" />
            </div>
          </UitkLayoutFlexItem>
          {!pageTitleStore.loading && (
            <UitkLayoutFlexItem>
              <p>{subTitle.longMessage}</p>
            </UitkLayoutFlexItem>
          )}
        </>
      </UitkLayoutFlex>
    );
  })
);
